export default __webpack_public_path__ + "static/media/PhotoPlant.5e1181d0.jpg";